function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrowSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    id: "svg2420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-17,-265)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.82533365,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 19.420118,269.01667 c -0.220879,0 -0.442006,0.0847 -0.611213,0.25413 -0.338414,0.33903 -0.338041,0.88488 5.72e-4,1.22379 l 7.562021,7.56526 7.562143,-7.56526 c 0.33804,-0.33891 0.33842,-0.88476 0,-1.22379 -0.16908,-0.16946 -0.38996,-0.254 -0.61059,-0.25413 h -5.7e-4 c -0.22088,0 -0.44151,0.0847 -0.61071,0.25413 l -6.340223,6.34271 -6.340095,-6.34271 c -0.169331,-0.16946 -0.390334,-0.25425 -0.611335,-0.25413 z",
    id: "rect24987-1-7-3-0-2-7-7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowSmall);
export default __webpack_public_path__ + "static/media/downArrowSmall.d97d8cbe.svg";
export { ForwardRef as ReactComponent };